import React, {useState, useRef, useEffect, useLayoutEffect} from "react";
import { Trans, Link, useTranslation, I18nextContext} from 'gatsby-plugin-react-i18next';
import {setTrap} from "../../utils/trap-focus";
import TransitionLink from "gatsby-plugin-transition-link/"
import './footer.scss';


export const Footer = ( {type, storeTeaser}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  
  const context = React.useContext(I18nextContext);
  let lang = context.language;
  // const [visiblePrivacy, setVisiblePrivacy] = useState(false);
  const modal = useRef(null);

  useLayoutEffect(() => {
    if(visible) {
      setTrap(modal.current);
    }
  }, [visible])

  useEffect(() => {
    if(document.body.classList.contains('exit-anim')){
      document.body.classList.remove('exit-anim')
    }
  },[])
  

  let toggleOverlay = (isShowing) => {
    setVisible(isShowing);
    let action = isShowing ? 'add' : 'remove';
    if((typeof window !== "undefined")){
      document.getElementsByTagName('body')[0].classList[action]('openOverlay');
    }
  };
  // let toggleOverlayPrivacy = (isShowing) => {
  //   setVisiblePrivacy(isShowing);
  //   let action = isShowing ? 'add' : 'remove';
  //   document.getElementsByTagName('body')[0].classList[action]('openOverlay');
  // };

  // function createMarkup() {
  //   return {__html: t('privacy text')};
  // }
  let link = type === 'teaser' ? '/teaser' : '/';
  const hideChangeLanguage = t('hideChangeLanguage') === 'true';
  let storeLink = storeTeaser ? '/stores-teaser' : '/stores'
 

  function exitAnim(){
    document.body.classList.add('glitch-anim')
  }

  function entryAnim(){
    document.body.classList.remove('glitch-anim')
  }

  return (
      <div className={`${type === 'teaser' ? 'footer--teaser' : ''} ${type === 'teaserstore' ? 'footer--teaserStore' : ''} ${type === 'white' ? 'footer--white' : ''} footer`}>
          {
             type === 'teaserstore'  ?
             (
               <div className="footer__linkCont">
                  <TransitionLink 
                  to={"/" + lang + '/teaser'} 
                  className="footer__link"
                  exit={{
                    length: 0.8,
                    trigger: ({ exit, node }) =>  exitAnim(exit, node),
            
                  }}
                  entry={{
                    delay: 0.8,
                    trigger: ({ entry, node }) =>  entryAnim(entry, node),
                  }}>
                    <svg fill="none" viewBox="0 0 10 8" className="footer__linkSvg">
                      <path d="m6.6667-7.9499e-8 -3.3333 3.3684 0.3125 0.31579 2.1042-2.1263c0.05824-0.0577 0.13195-0.09686 0.21201-0.11262 0.08005-0.01577 0.16293-0.00744 0.23834 0.02394 0.07542 0.03138 0.14007 0.08444 0.18593 0.15259 0.04585 0.06816 0.07091 0.14842 0.07205 0.23083v4.0421c0.00318 0.22218-0.03757 0.44276-0.11985 0.64882s-0.20444 0.39345-0.35931 0.55118c-0.31751 0.31279-0.74409 0.48673-1.1875 0.48421h-4.7917l5.021e-9 0.42105h4.7917c0.55231-0.00416 1.0819-0.22275 1.4792-0.61053 0.38375-0.40144 0.60006-0.9366 0.60417-1.4947v-4.0421c0.00115-0.08241 0.0262-0.16267 0.07206-0.23083 0.04586-0.06815 0.1105-0.12121 0.18592-0.15259s0.15829-0.03971 0.23835-0.02394c0.08005 0.01576 0.15377 0.05492 0.212 0.11262l2.1042 2.1263 0.3125-0.31579-3.3333-3.3684z" fill="#000"/>
                  </svg>
                    <Trans>back to home</Trans>
                  </TransitionLink>

                </div>
             
             ) : (
            <div className="footer__linkStore"> 
              <TransitionLink className = "footer__link"
              exit={{
                length: 0.8,
                trigger: ({ exit, node }) =>  exitAnim(exit, node),
        
              }}
              entry={{
                delay: 0.8,
                trigger: ({ entry, node }) =>  entryAnim(entry, node),
              }}
              to={"/" + lang + storeLink}  >
                 <Trans>locator label</Trans>
              </TransitionLink>
            </div>
             )
            
          }
          {
              (type === 'teaser' || type === 'teaserstore') && 
              <div className="footer__privacy">
                <a href={t('privacy text')} target="_blank" className="footer__link footer__link--icon">
                  <Trans>privacy label</Trans>
                </a>
            
              {/* <div className={`${visiblePrivacy ? '' : 'overlayWrapper--hidden'} overlayWrapper`}>
                <div className="overlay" ref={modalPrivacy}>
                  <a href={t('privacy text')} className="overlay__close" >
                    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="30.4144" y="29" width="20" height="2" rx="1" transform="rotate(45 30.4144 29)" fill="black"/>
                      <rect x="29.4144" y="43.1421" width="20" height="2" rx="1" transform="rotate(-45 29.4144 43.1421)" fill="black"/>
                    </svg>
                    <span className="overlay__closeLabel" ><Trans>close</Trans></span>
                  </a>
                  <div className="overlay__content">
                    <h3 className="overlay__title">
                      <Trans>privacy label</Trans>
                    </h3>
                    <div dangerouslySetInnerHTML={createMarkup()}></div>
                  </div>
                </div>
              </div> */}
            </div>
          }
          {
            !hideChangeLanguage &&
            <div className="footer__lang">
              <a href="#" className="footer__link footer__link--icon" onClick={() => toggleOverlay(true)}>
                <Trans>language label</Trans>
                <svg width="6" height="4" viewBox="0 0 6 4" fill="none" className="footer__linkSvg">
                  <path d="M5.30336 2.70705L3.18204 0.585731C2.98678 0.390469 2.6702 0.390469 2.47494 0.585731C2.27968 0.780993 2.27968 1.09758 2.47494 1.29284L4.59626 3.41416C4.79152 3.60942 5.1081 3.60942 5.30336 3.41416C5.49863 3.2189 5.49863 2.90231 5.30336 2.70705Z" fill="#2B2B2B"/>
                  <path d="M1.06065 3.4142L3.18197 1.29288C3.37723 1.09762 3.37723 0.78104 3.18197 0.585778C2.98671 0.390516 2.67012 0.390516 2.47486 0.585778L0.353542 2.7071C0.15828 2.90236 0.15828 3.21894 0.353542 3.4142C0.548804 3.60947 0.865387 3.60947 1.06065 3.4142Z" fill="#2B2B2B"/>
                </svg>
              </a>
              
              <div className={`${visible ? '' : 'overlayWrapper--hidden'} overlayWrapper`}>
                <div className="overlay" ref={modal}>
                  <a href="#" className="overlay__close" onClick={() => toggleOverlay(false)} tabIndex={`${visible  ? '0' : '-1'}`}>
                    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="30.4144" y="29" width="20" height="2" rx="1" transform="rotate(45 30.4144 29)" fill="black"/>
                      <rect x="29.4144" y="43.1421" width="20" height="2" rx="1" transform="rotate(-45 29.4144 43.1421)" fill="black"/>
                    </svg>
                    <span className="overlay__closeLabel" ><Trans>close</Trans></span>
                  </a>
                  <div className="overlay__content">
                    <h3 className="overlay__title">
                    <Trans>change language</Trans>
                    </h3>
                      <ul className="regionList__langList">
                        <li className="langList__item">
                          <Link to={link} language="en" className="langList__link" tabIndex={`${visible  ? '0' : '-1'}`}>
                            <Trans>English</Trans>
                          </Link>
                        </li>
                        <li className="langList__item">
                          <a href={`https://www.loropiana.cn/hiroshifujiwara/zh_hans${link}`} className="langList__link" tabIndex={`${visible  ? '0' : '-1'}`}>
                            <Trans>chinese_SIMPLIFIED</Trans>
                          </a>
                        </li>
                        <li className="langList__item">
                          <Link to={link} language="zh_hant" className="langList__link" tabIndex={`${visible  ? '0' : '-1'}`}>
                            <Trans>CHINESE_TRADITIONAL</Trans>
                          </Link>
                        </li>
                        <li className="langList__item">
                          <Link to={link} language="fr" className="langList__link" tabIndex={`${visible  ? '0' : '-1'}`}>
                            <Trans>French</Trans>
                          </Link>
                        </li>
                        <li className="langList__item">
                          <Link to={link} language="de" className="langList__link" tabIndex={`${visible  ? '0' : '-1'}`}>
                            <Trans>German</Trans>
                          </Link>
                        </li>
                        <li className="langList__item">
                          <Link to={link} language="it" className="langList__link" tabIndex={`${visible  ? '0' : '-1'}`}>
                            <Trans>Italian</Trans>
                          </Link>
                        </li>
                        
                        <li className="langList__item">
                          <Link to={link} language="ja" className="langList__link" tabIndex={`${visible  ? '0' : '-1'}`}>
                            <Trans>Japanese</Trans>
                          </Link>
                        </li>
                        <li className="langList__item">
                          <Link to={link} language="ko" className="langList__link" tabIndex={`${visible  ? '0' : '-1'}`}>
                            <Trans>Korean</Trans>
                          </Link>
                        </li>
                        <li className="langList__item">
                          <Link to={link} language="ru" className="langList__link" tabIndex={`${visible  ? '0' : '-1'}`}>
                            <Trans>Russian</Trans>
                          </Link>
                        </li>
                      </ul>
                  </div>
                </div>
              </div>
            </div>
          }
          
      </div>
    )
  }